<template>
    <div>
        <breadcrumb :routerList="[{to:'/activity/activityInfo',title:'推广列表'},{title:'新增营销推广活动'}]"/>

        <div class="h-content">

            <div class="h-row h-mrt0">
                <div class="h-rowIn">

                    <div class="h-rowBox">
                        <el-form  ref="form1" :model="f"  :rules="finalRules">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>{{title}}</h1>
                                    </div>
                                    <div class="h-pieceCon2">


                                        <div class="h-formLine ">

                                            <div class="margin-top el-descriptions">
                                                <div class="el-descriptions__body">

                                                    <table class ="meeting-table el-descriptions__table is-bordered ">

                                                        <tr>
                                                            <th colspan="13" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label" style="font-weight: bold;">基本信息</th>
                                                        </tr>

                                                        <tr>
                                                            <th colspan="5" >
                                                                省市
                                                            </th>
                                                            <td colspan="8" class=" ">
                                                                <el-form-item  prop="provinceCity" >
                                                                    <el-input v-model="f.provinceCity"   placeholder="请输入"></el-input>
                                                                </el-form-item>

                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <th colspan="5" >
                                                                {{ companyLabel }}
                                                            </th>
                                                            <td colspan="8">
                                                                <el-form-item prop="companyName">
                                                                    <el-select
                                                                        :disabled="isEdit"
                                                                        filterable
                                                                        remote
                                                                        reserve-keyword
                                                                        v-model="f.companyName"
                                                                        placeholder="请输入关键词进行搜索"
                                                                        @change="changeCompany"
                                                                        :remote-method="companySearch"
                                                                        :loading="searchLoading"
                                                                        style="width: 100%;"
                                                                        allow-create
                                                                        default-first-option
                                                                        clearable
                                                                    >
                                                                        <el-option
                                                                            v-for="item in companyList"
                                                                            :key="item.companyCode"
                                                                            :label="`${item.companyCode} ${item.companyName}`"
                                                                            :value="item.companyCode"
                                                                        />
                                                                    </el-select>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <th colspan="5" >提报人姓名</th>
                                                            <td colspan="8" >
                                                                <el-form-item prop="reporterName">
                                                                    <el-input v-model="f.reporterName" placeholder="请输入" ></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <th colspan="5" >联系电话</th>
                                                            <td colspan="8" >
                                                                <el-form-item prop="contactPhone">
                                                                    <el-input v-model="f.contactPhone" placeholder="请输入" ></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <th colspan="5" >
                                                             {{eventNameLabel}}
                                                            </th>
                                                            <td colspan="8" >
                                                                <el-form-item prop="eventName">
                                                                    <el-input v-model="f.eventName" placeholder="请输入" ></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <th colspan="5" >
                                                                {{eventTimeLabel}}
                                                            </th>
                                                            <td  colspan="8" >
                                                                <el-form-item  prop="eventTime" >
                                                                    <el-date-picker
                                                                        :clearable="true"
                                                                        type="date"
                                                                        value-format="yyyy-MM-dd"
                                                                        placeholder="选择时间"
                                                                        v-model="f.eventTime"
                                                                        style="width: 100%;"
                                                                    ></el-date-picker>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>

                                                    <!--交互用户（姓名职务电话）仅仅润心-->
                                                        <tr v-if="f.activityType === '润心巡检'">
                                                            <th colspan="5" >
                                                                交互用户（姓名职务电话）
                                                            </th>
                                                            <td colspan="8" >
                                                                <el-form-item prop="interactionUsers">
                                                                    <el-input v-model="f.interactionUsers" placeholder="请输入" ></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>

                                                        <!--参与人数 仅渠道会议-->
                                                        <tr v-if="f.activityType === '渠道会用户会' ">
                                                            <th colspan="5" >
                                                                参与人数
                                                            </th>
                                                            <td colspan="8" >
                                                                <el-form-item prop="participantCount">
                                                                    <el-input v-model="f.participantCount" placeholder="请输入" ></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>
                                                        <!--展会地点 仅展会-->
                                                        <tr v-if="f.activityType === '区域展会' ">
                                                            <th colspan="5" >
                                                                展会地点
                                                            </th>
                                                            <td colspan="8" >
                                                                <el-form-item prop="eventLocation">
                                                                    <el-input v-model="f.eventLocation" placeholder="请输入" ></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="f.activityType === '区域展会' ">
                                                            <th colspan="5" >
                                                                展会主办方（参展费收款公司名称）
                                                            </th>
                                                            <td colspan="8" >
                                                                <el-form-item prop="eventOrganizer">
                                                                    <el-input v-model="f.eventOrganizer" placeholder="请输入" ></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>




                                                        <tr>
                                                            <th colspan="13" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label" style="font-weight: bold;">
                                                                推动在手线索
                                                            </th>
                                                        </tr>
                                                        <!-- 遍历动态线索列表，每个条目一行：漏斗编号、金额、操作 -->
                                                        <tr v-for="(detail, idx) in f.detailZSClueList" :key="'zs_' + idx">
                                                            <th  colspan="2"  style="width: 140px;">漏斗编号</th>
                                                            <td  colspan="4" >
                                                                <el-input v-model="detail.funnelCode" placeholder="请输入漏斗编号" clearable></el-input>
                                                            </td>
                                                            <th colspan="2" >金额</th>
                                                            <td colspan="4" >
                                                                <el-input type= 'number' v-model="detail.leadAmount" placeholder="请输入金额" clearable></el-input>
                                                            </td>
                                                            <td  colspan="1" class="dynamic-line-action" style="width: 100px; text-align: center;">
                                                                <el-button type="text" icon="el-icon-delete" style="color: #F56C6C;" @click="removeDetailRow(idx)" :disabled="f.detailZSClueList.length <= 1">删除</el-button>
                                                            </td>
                                                        </tr>
                                                        <!-- 新增按钮行 -->
                                                        <tr>
                                                            <td colspan="13" class="action-bar-cell">
                                                                <el-button type="primary" size="small" icon="el-icon-plus" plain @click="addDetailRow">新增一行</el-button>
                                                            </td>
                                                        </tr>


                                                        <tr>
                                                            <th  colspan = 13 class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label" style="font-weight: bold;">新获取线索</th>
                                                        </tr>

                                                        <tr v-for="(detail, idx) in f.detailNewClueList" :key="'new_' + idx" >
                                                            <th >单位</th>
                                                            <td >
                                                                <el-input v-model="detail.unitName" placeholder="请输入单位"></el-input>
                                                            </td>
                                                            <th >姓名</th>
                                                            <td >
                                                                <el-input v-model="detail.contactPerson" placeholder="请输入姓名"></el-input>
                                                            </td>
                                                            <th >电话</th>
                                                            <td >
                                                                <el-input v-model="detail.contactPhone" placeholder="请输入电话"></el-input>
                                                            </td>
                                                            <th >采购需求</th>
                                                            <td >
                                                                <el-input v-model="detail.procurementNeeds" type ="textarea" placeholder="请输入采购需求"></el-input>
                                                            </td>
                                                            <th v-if="f.activityType === '区域展会'">邮箱</th>
                                                            <th v-else ></th>
                                                            <td v-if="f.activityType === '区域展会'">
                                                                <el-input v-model="detail.email" placeholder="请输入邮箱"></el-input>
                                                            </td>
                                                            <td v-else> </td>

                                                            <th >预估金额</th>
                                                            <td >
                                                                <el-input type= 'number' v-model="detail.estimatedAmount" placeholder="请输入预估金额"></el-input>
                                                            </td>

                                                            <td class="dynamic-line-action" style="width: 100px; text-align: center;">
                                                                <el-button type="text" icon="el-icon-delete" style="color: #F56C6C;" @click="removeDetailNewRow(idx)" :disabled="f.detailNewClueList.length <= 1">删除</el-button>
                                                            </td>
                                                        </tr>
                                                        <!-- 新增按钮行 -->
                                                        <tr>
                                                            <td  colspan="13" class="action-bar-cell">
                                                                <el-button type="primary" size="small" icon="el-icon-plus" plain @click="addDetailNewRow">新增一行</el-button>
                                                            </td>
                                                        </tr>

                                                        <!-- 仅 高校，渠道 -->
                                                        <tr v-if="f.activityType === '高校巡展'|| f.activityType === '渠道会用户会'  || f.activityType === '区域展会'">
                                                            <th colspan="5" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                                事前报备表(请示报告单或官方邀请函) <br/>上传PDF、EXCEL、图片等文件
                                                            </th>
                                                            <td colspan="8" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <brupload
                                                                    :refid="refid"
                                                                    reftype="activity_事前报备表"
                                                                    :uploadflag="true"
                                                                    :delflag="true"
                                                                    :showtime="false">
                                                                </brupload>
                                                            </td>

                                                        </tr>
                                                        <!-- 仅 高校，渠道 -->
                                                        <tr v-if="f.activityType === '高校巡展'|| f.activityType === '渠道会用户会' || f.activityType === '区域展会' ">
                                                            <th colspan="5" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                                参会签到表(必须是通过电子二维码签到的表单) <br/>上传EXCEL、图片等文件
                                                            </th>
                                                            <td colspan="8" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <brupload
                                                                    :refid="refid"
                                                                    reftype="activity_参会签到表"
                                                                    :uploadflag="true"
                                                                    :delflag="true"
                                                                    :showtime="false">
                                                                </brupload>
                                                            </td>
                                                        </tr>

                                                        <!--   润心产品及数量 仅 润心   -->
                                                        <tr v-if="f.activityType === '润心巡检'">
                                                            <th colspan="5">
                                                                润心产品及数量
                                                            </th>
                                                            <td colspan="8" >
                                                                <el-form-item  prop="productQty" >
                                                                    <el-input  v-model="f.productQty" placeholder="请输入"></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>


                                                    <!--  市场销售人员是否到场具体填写( 仅润心)    -->
                                                        <tr v-if="f.activityType === '润心巡检'">
                                                            <th colspan="5">
                                                                市场销售人员是否到场具体填写
                                                            </th>
                                                            <td colspan="8" >
                                                                <el-form-item  prop="salespersonPresent" >
                                                                    <el-input v-model="f.salespersonPresent" placeholder="请输入"></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>

                                                        <!--   高校巡展    -->
                                                        <tr v-if="f.activityType === '高校巡展'">
                                                            <th colspan="5" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                                巡展照片(上传展示、交互、服务照片等)<br/>上传图片
                                                            </th>

                                                            <td colspan="8" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <brupload
                                                                    :isTp = true
                                                                    :tpFlag = true
                                                                    :refid="refid"
                                                                    reftype="activity_巡展照片"
                                                                    :uploadflag="true"
                                                                    :delflag="true"
                                                                    :showtime="false">
                                                                </brupload>
                                                            </td>
                                                        </tr>

                                                        <!--   仅 润心巡检    -->
                                                        <tr v-if="f.activityType === '润心巡检'">
                                                            <th colspan="5" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                                润心照片（上传服务、交互、合影照片等）<br/>上传图片
                                                            </th>

                                                            <td colspan="8" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <brupload
                                                                    :isTp = true
                                                                    :tpFlag = true
                                                                    :refid="refid"
                                                                    reftype="activity_润心照片"
                                                                    :uploadflag="true"
                                                                    :delflag="true"
                                                                    :showtime="false">
                                                                </brupload>
                                                            </td>
                                                        </tr>
                                                        <!--   渠道会用户会    -->
                                                        <tr v-if="f.activityType === '渠道会用户会' ">
                                                            <th colspan="5" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                                活动照片（上传签到、展示、发布、交互、宴请等）<br/>上传图片
                                                            </th>

                                                            <td colspan="8" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <brupload
                                                                    :isTp = true
                                                                    :tpFlag = true
                                                                    :refid="refid"
                                                                    reftype="activity_活动照片"
                                                                    :uploadflag="true"
                                                                    :delflag="true"
                                                                    :showtime="false">
                                                                </brupload>
                                                            </td>
                                                        </tr>

                                                        <!--   展会照片    -->
                                                        <tr v-if="f.activityType === '区域展会' ">
                                                            <th colspan="5" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                                展会照片（上传签到、展示、发布、交互、宴请等）<br/>上传图片
                                                            </th>

                                                            <td colspan="8" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <brupload
                                                                    :isTp = true
                                                                    :tpFlag = true
                                                                    :refid="refid"
                                                                    reftype="activity_展会照片"
                                                                    :uploadflag="true"
                                                                    :delflag="true"
                                                                    :showtime="false">
                                                                </brupload>
                                                            </td>
                                                        </tr>




                                                        <tr>
                                                            <th colspan="5">
                                                                其他会议效果总结
                                                            </th>
                                                            <td colspan="8" >
                                                                <el-form-item  prop="mainSummary"  >
                                                                    <el-input v-model="f.mainSummary" placeholder="请输入"></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>

                                                    <!--     仅 高校巡展， 渠道会用户会   -->
                                                        <tr v-if="f.activityType === '高校巡展'|| f.activityType === '渠道会用户会' || f.activityType === '区域展会'">
                                                            <th colspan="5">
                                                                总共发生费用(元)
                                                            </th>
                                                            <td colspan="8" >
                                                                <el-form-item  prop="totalExpense" >
                                                                    <el-input  type="number" v-model="f.totalExpense" placeholder="请输入金额"></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>

                                                        <!--      高校巡展， 渠道会用户会   -->
                                                        <tr v-if="f.activityType === '高校巡展'|| f.activityType === '渠道会用户会' || f.activityType === '区域展会'">
                                                            <th colspan="5" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                                上传费用发生凭证（发票、协议、合同、支付记录等）<br/>上传PDF、EXCEL、图片等文件
                                                            </th>

                                                            <td colspan="8" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <brupload
                                                                    :refid="refid"
                                                                    reftype="activity_上传费用发生凭证"
                                                                    :uploadflag="true"
                                                                    :delflag="true"
                                                                    :showtime="false">
                                                                </brupload>
                                                            </td>
                                                        </tr>

                                                        <!--   仅  润心   -->
                                                        <tr v-if="f.activityType === '润心巡检'">
                                                            <th colspan="5">
                                                                需求及建议
                                                            </th>
                                                            <td colspan="8" >
                                                                <el-form-item  prop="needsSuggestions"  >
                                                                    <el-input  v-model="f.needsSuggestions" placeholder="请输入"></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>


                                                    </table>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>

            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="submit">确认提交</el-button>

            </div>

        </div>

        <!-- 新增活动类型选择弹窗 -->
        <el-dialog
            title="请选择活动类型"
            :visible.sync="activityTypeDialogVisible"
            width="30%"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            center>
            <div style="text-align: center; padding: 20px 0;">
                <el-radio-group v-model="f.activityType" @change="changeActivityType">
                    <el-radio-button label="渠道会用户会">渠道会用户会</el-radio-button>
                    <el-radio-button label="高校巡展">高校巡展</el-radio-button>
                    <el-radio-button label="润心巡检">润心巡检</el-radio-button>
                    <el-radio-button label="区域展会">区域展会</el-radio-button>
                </el-radio-group>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmActivityType">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>

import activityInfo from "@/api/loud/activity/activityInfo.js";

export default {

    components: {


    },

    data() {

        return {
            searchLoading: false,
            showshdfdialog: false,
            selectDailishang: true,
            companyList: [],
            refid:null,
            // 新增：标识是新增还是编辑
            isEdit: false,
            editId: null, // 编辑的ID
            // 新增弹窗相关数据
            activityTypeDialogVisible: true, // 控制弹窗显示
            //表单
            f:{
                activityType: null,//活动类型：高校巡展 / 渠道会用户会 / 润心巡检  /区域展会  默认选中第一个
                provinceCity:null, //省市
                companyCode:null, // 客户或经销商编码
                companyName:null, // 客户或经销商名称
                reporterName:null,//提报人姓名
                contactPhone:null,//联系电话
                eventName:null,//巡展高校（院系),润心单位 ,活动名称
                eventTime:null,//润心时间/活动时间/巡展时间
                participantCount:null,//参与人数 - 仅渠道
                eventLocation:null,//展会地点- 仅展会
                eventOrganizer:null,//展会主办方- 仅展会
                interactionUsers:null,//交互用户信息（姓名职务电话）-仅润心
                mainSummary:null,//其他润心效果总结/其他会议效果总结/其他巡展效果总结
                totalExpense:null,//总共发生费用
                salespersonPresent:null,//市场销售人员是否到场(润心)
                productQty:null,//润心产品及数量（润心）
                needsSuggestions:null,//需求及建议（润心）
                // 推动在手线索
                detailZSClueList: [
                    { funnelCode: '', leadAmount: '' }
                ],
                // 新线索
                detailNewClueList: [
                    { unitName: '', contactPerson: '', contactPhone:'',email:'', procurementNeeds:'', estimatedAmount:'' }
                ]

            },
            //客户名称
            companyLabel:"",
            //单位或活动名称
            eventNameLabel:"",
            //活动时间
            eventTimeLabel:"",
            //title
            title:"",

            rules: {
                provinceCity: [{required: true, message: '请填写省市', trigger: 'blur'}],
                companyName: [{required: true, message: '请选择经销商/客户', trigger: 'change'}],
                reporterName: [{required: true, message: '请填写提报人姓名', trigger: 'blur'}],
                contactPhone: [
                    {required: true, message: '请填写联系电话', trigger: 'blur'}
                ],
                eventName: [{required: true, message: '请填写活动名称/单位', trigger: 'blur'}],
                eventTime: [{required: true, message: '请选择时间', trigger: 'change'}],
                mainSummary: [{required: true, message: '请填写会议效果总结', trigger: 'blur'}],


            },

            // 动态校验规则
            dynamicRules: {
                participantCount: [{required: true, message: '请填写参与人数', trigger: 'blur'}],
                interactionUsers: [{required: true, message: '请填写交互用户信息', trigger: 'blur'}],
                productQty: [{required: true, message: '请填写润心产品及数量', trigger: 'blur'}],
                salespersonPresent: [{required: true, message: '请填写市场销售人员是否到场', trigger: 'blur'}],
                totalExpense: [
                    {required: true, message: '请填写总共发生费用', trigger: 'blur'},
                    {pattern: /^\d+(\.\d{1,2})?$/, message: '请输入正确的金额格式', trigger: 'blur'}
                ],
                needsSuggestions: [{required: true, message: '请填写需求及建议', trigger: 'blur'}]
            }


        }
    },

    created() {
        // 检查路由参数，判断是新增还是编辑
        const id = this.$route.query.id;
        if (id && id !== 'null' && id !== 'undefined') {
            this.refid = id;
            this.isEdit = true;
            this.editId = id;
            this.activityTypeDialogVisible = false; // 编辑模式下关闭弹窗
            this.query(id);
            this.title="修改营销推广活动";
        } else {
            this.refid = this.$util.getUuid();
            this.isEdit = false;
            this.changeActivityType();
            this.title="新增营销推广活动";
        }

    },
    computed : {
        // 动态合并校验规则
        finalRules() {
            const baseRules = { ...this.rules }
            const type = this.f.activityType

            if (type === '渠道会用户会') {
                baseRules.participantCount = this.dynamicRules.participantCount
                baseRules.totalExpense = this.dynamicRules.totalExpense
            } else if (type === '润心巡检') {
                baseRules.interactionUsers = this.dynamicRules.interactionUsers
                baseRules.productQty = this.dynamicRules.productQty
                baseRules.salespersonPresent = this.dynamicRules.salespersonPresent
                baseRules.needsSuggestions = this.dynamicRules.needsSuggestions
            } else if (type === '高校巡展') {
                baseRules.totalExpense = this.dynamicRules.totalExpense
            }

            return baseRules
        },
        //
        newClueColspan() {
            return this.f.activityType === '区域展会' ? 13 : 11
        }


    },


    methods: {
        // 根据id加载活动详情
        query(id) {
            activityInfo.selectById(id).then(rd => {
                this.f = rd.obj;
                this.changeActivityType( this.f.activityType);
            });
        },


        //返回
        backS() {
            this.$router.go(-1);
        },

        confirmActivityType() {
            if(!this.f.activityType){
                this.$message.warning('请选择活动类型');
                return;
            }
            // 关闭弹窗
            this.activityTypeDialogVisible = false;
        },

        //选择活动类型
        changeActivityType(val){

            const type = val !== undefined ? val : this.f.activityType;

            if (type === '高校巡展') {
                this.eventNameLabel = '巡展高校(院系)';
                this.eventTimeLabel = '巡展时间';
                this.companyLabel = '主要参与海尔经销商单位名称';

            } else if (type === '润心巡检') {
                this.companyLabel = '客户单位名称';
                this.eventNameLabel = '润心单位';
                this.eventTimeLabel = '润心时间';

            }else if (type === '渠道会用户会' ) {
                this.companyLabel = '主要参与海尔经销商单位名称';
                this.eventNameLabel = '活动名称';
                this.eventTimeLabel = '活动时间';
            }else if (type === '区域展会' ) {
                this.companyLabel = '主要参与海尔经销商单位名称';
                this.eventNameLabel = '展会名称';
                this.eventTimeLabel = '展会时间';
            }



        },
        //选择经销商
        changeCompany(val) {
            console.log("val====",val)
            const company = this.companyList.find(item => item.companyCode === val);

            if (company) {
                // 从列表中选择的公司
                this.f.companyName = company.companyName;
                this.f.companyCode = company.companyCode;
            } else {
                // 手动输入的公司名称
                this.f.companyName = val;
                this.f.companyCode = null; // 手动输入时编码为空
            }



        },
        //查询经销商
        companySearch(query) {
            console.log("query",query)
            // 如果查询词为空，可以清空下拉选项或跳过请求
            if (!query) {
                this.companyList = []
                return
            }

            activityInfo.selectCompanyList(query).then(response => {
                const resultList = response.msg
                this.companyList = resultList.map(item => ({
                    companyCode: item.usercode,
                    companyName: item.username
                }))
            })

        },



        // 新增在手线索行: 动态增加一行空白线索
        addDetailRow() {
            this.f.detailZSClueList.push({
                funnelCode: '',
                leadAmount: ''
            });
            this.$message({ type: 'success', message: '已新增一行线索', duration: 1500 });
        },
        // 删除指定索引的线索行
        removeDetailRow(index) {
            this.f.detailZSClueList.splice(index, 1);
            this.$message({ type: 'success', message: '删除成功' });
        },


        // 新增新线索行:
        addDetailNewRow() {
            this.f.detailNewClueList.push({
                unitName: '',
                contactPerson: '',
                contactPhone:'',
                procurementNeeds:'',
                email:'',
                estimatedAmount:''

            });
            this.$message({ type: 'success', message: '已新增一行线索', duration: 1500 });
        },
        // 删除指定索引的线索行
        removeDetailNewRow(index) {

            this.f.detailNewClueList.splice(index, 1);
            this.$message({ type: 'success', message: '删除成功' });
        },

        //提交
        submit() {

            var subflag = false;
            this.$refs['form1'].validate((valid) => {
                if (valid) {
                    subflag = true;
                } else {
                    this.$msg.msge("请完善信息后再提交！");
                    return false;
                }
            });
            // 校验动态表格
            if (!this.validateDynamicTables()) {
                return;
            }



            if (subflag == true) {
                this.$msg.confirm("确认提交该信息?", () => {

                    //如是修改
                    if(this.isEdit){
                        activityInfo.updateById(this.f).then(rd => {
                            if (rd.f) {
                                this.$msg.msgs("修改成功！")
                                this.$router.push({ path: '/activity/activityInfo' })
                            }
                        })
                    }else{
                        this.f.id = this.refid
                        activityInfo.insert(this.f).then(rd => {
                            if (rd.f) {
                                this.$msg.msgs("提交成功！")
                                this.$router.push({ path: '/activity/activityInfo' })
                            }

                        })
                    }
                });
            }

        },


        // 校验动态表格
        validateDynamicTables() {
            // 校验推动在手线索
            for (let i = 0; i < this.f.detailZSClueList.length; i++) {
                const item = this.f.detailZSClueList[i];
                // 如果有内容，校验必填
                if (item.funnelCode || item.leadAmount) {
                    if (!item.funnelCode) {
                        this.$msg.msge(`第${i+1}行线索的"漏斗编号"不能为空！`);
                        return false;
                    }
                    if (!item.leadAmount) {
                        this.$msg.msge(`第${i+1}行线索的"金额"不能为空！`);
                        return false;
                    }
                }
            }

            // 校验新获取线索
            for (let i = 0; i < this.f.detailNewClueList.length; i++) {
                const item = this.f.detailNewClueList[i];
                // 如果有任何字段有值，则所有字段都必填
                const hasValue = item.unitName || item.contactPerson || item.contactPhone ||
                    item.procurementNeeds || item.estimatedAmount;
                if (hasValue) {
                    if (!item.unitName) {
                        this.$msg.msge(`第${i+1}行新线索的"单位"不能为空！`);
                        return false;
                    }
                    if (!item.contactPerson) {
                        this.$msg.msge(`第${i+1}行新线索的"姓名"不能为空！`);
                        return false;
                    }
                    if (!item.contactPhone) {
                        this.$msg.msge(`第${i+1}行新线索的"电话"不能为空！`);
                        return false;
                    }
                    if (!item.procurementNeeds) {
                        this.$msg.msge(`第${i+1}行新线索的"采购需求"不能为空！`);
                        return false;
                    }
                    // 区域展会时校验邮箱
                    if (this.f.activityType === '区域展会' && !item.email) {
                        this.$msg.msge(`第${i+1}行新线索的"邮箱"不能为空！`);
                        return false;
                    }
                    if (!item.estimatedAmount) {
                        this.$msg.msge(`第${i+1}行新线索的"预估金额"不能为空！`);
                        return false;
                    }
                }
            }

            return true;
        }



    }

}


</script>
<style scoped lang="scss">
::v-deep .meeting-table  th ,td {

    text-align: center!important;
    border: 1px solid #303133!important;
    vertical-align:middle;

}
::v-deep .my-label {
    background: #fff2e5!important;

}
::v-deep .my-label-lab {
    background: #E8F5F8!important;

}
::v-deep.ljjtablepaddings1 .h-tableInput .el-input__icon{
    line-height: 0.25rem;
}

::v-deep .el-form-item {
    margin-bottom: 0 !important;
}
</style>
